import './styles.css';

type SquareProps = {
	mark?: string,
	className?: string
}; 

const Square = ( {mark='', className=''}: SquareProps): JSX.Element => {
	const disabled = mark !== ''

	return (
		<button className={`player ${className}`} disabled={disabled} aria-label={`Place ${mark}`}>{mark}</button>
	);
}

export default Square;